export default "<app-navbar></app-navbar>\n<app-header></app-header>\n<router-outlet></router-outlet>";